import { render, staticRenderFns } from "./ProductCreateOrUpdate.vue?vue&type=template&id=4e9da83c&"
import script from "./ProductCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports